import React, { Component } from 'react';
import pmc from "./images/buttons/pmc.png";
import pubmed from "./images/buttons/pubmed.png";
import researchgate from "./images/buttons/researchgate.png";
import pdf from "./images/buttons/acrobat.svg";
import google from './images/buttons/google.png';


class PubButtons extends Component {
  render() {
    let button_list = [];
    (this.props.pubmed) &&
    button_list.push(
      <a href={"https://www.ncbi.nlm.nih.gov/pubmed/?term="+this.props.pubmed}
        key="pubmed" rel="noopener noreferrer" target="_blank">
        <img src={pubmed} alt="PubMed"/>
      </a>
    );
    (this.props.pmc) &&
    button_list.push(
      <a href={"https://www.ncbi.nlm.nih.gov/pmc/articles/"+this.props.pmc}
        key="pmc" rel="noopener noreferrer" target="_blank">
        <img src={pmc} alt="PubMed Central"/>
      </a>
    );
    (this.props.researchgate) &&
    button_list.push(
      <a href={"https://www.researchgate.net/publication/"+this.props.researchgate}
        key="rgate" rel="noopener noreferrer" target="_blank">
        <img src={researchgate} alt="ResearchGate"/>
      </a>
    );
    (this.props.pdf) &&
    button_list.push(
      <a href={"https://moreygenetics.com/pdf/"+this.props.pdf}
        key="pdf" rel="noopener noreferrer" target="_blank">
        <img src={pdf} alt="PDF" style={{"backgroundColor":"#b30b00"}}/>
      </a>
    );
    (this.props.url) &&
    button_list.push(
      <a href={this.props.url}
        key="url" rel="noopener noreferrer" target="_blank"
        style={{textAlign:"center"}}>
        <span role="img" style={{"backgroundColor":"white"}} aria-label="url">🌐</span>
      </a>
    );
    
    !((this.props.type) && (this.props.type === "web")) &&
    button_list.push(
      <a href={"https://scholar.google.com/scholar?q="+this.props.title}
        key="google" rel="noopener noreferrer" target="_blank">
        <img src={google} alt="Google Scholar"/>
      </a>
    )

    return (
      <div className="buttons">
        {button_list}
      </div>
    )
  }
}
export default PubButtons;